import { AgPieSeriesItemStylerParams, AgPieSeriesStyle, Styler } from 'ag-charts-community'

type PerIssuerItemStyler<T extends { product_issuer: string } = any> = Styler<
  AgPieSeriesItemStylerParams<T, any>,
  AgPieSeriesStyle
>

export const perIssuerItemStyler: PerIssuerItemStyler = (params) => {
  const colours: Record<string, string> = {
    'UK Gov': '#1E90FF',
    'USA Gov': '#90EE90',
    Aswap: '#FF4433',
    'Corp Bonds': '#FFD700', // golden yellow — energetic, contrasts blue/red/green
    'Financial Bonds': '#9370DB', // medium purple — elegant, distinct from others
    'Funding Trade': '#FF8C00', // deep orange — vibrant, ties well with red/yellow tones
    'Sov. Agencies': '#20B2AA', // teal — balanced cool tone, contrasts warm ones
    'Supra Bonds': '#C71585',
  }

  return { fill: colours[params.datum.product_issuer] }
}
